import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-mat-outlined-button',
  templateUrl: './mat-outlined-button.component.html',
  styleUrls: ['./mat-outlined-button.component.scss'],
  imports: [MatIconModule, MatButtonModule, MatRippleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatOutlinedButtonComponent {
  /** ID for the button element (optional)*/
  buttonId = input<string | undefined>(undefined);

  /** The button color style (optional, default: 'primary') */
  buttonStyle = input<'primary' | 'accent' | 'warn' | 'default' | 'grey' | 'selected' | 'negative' | 'dark-blue'>('primary');

  /** The position of the icon relative to the label (optional,       
  default: 'left') */
  iconPosition = input<'left' | 'right'>('left');

  /** The name of the material icon to display (optional) */
  iconName = input<string>();

  /** The button text label (required) */
  label = input<string>();

  /** The HTML button type attribute (optional, default: 'button') */
  buttonType = input<'button' | 'submit' | 'reset'>('button');

  /** Whether the button is disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** ARIA label for accessibility (optional, falls back to label) */
  ariaLabel = input<string>();

  /** Event emitted when the button is clicked */
  buttonClicked = output<void>();

  /** Handles the button click event and emits the buttonClicked event */
  clickButton = (): void => {
    this.buttonClicked.emit();
  };
}
